import { css, html, LitElement } from "lit";

import { controlStyles } from "../styles/tokens";

/**
 * <modulina-select> — labeled dropdown (klientas/projektas filters).
 * Props-in/events-out: options + value in, one `change` CustomEvent
 * (detail: { value }) out. No decorators anywhere in ui/ (pure `bun build`,
 * owner stack decision): `static properties` + `declare` fields.
 */

export interface SelectOption {
  value: string;
  label: string;
}

export class ModulinaSelect extends LitElement {
  static override properties = {
    label: {},
    placeholder: {},
    value: {},
    disabled: { type: Boolean },
    options: { attribute: false },
  };

  declare label: string;
  declare placeholder: string;
  declare value: string;
  declare disabled: boolean;
  declare options: SelectOption[];

  constructor() {
    super();
    this.label = "";
    this.placeholder = "— pasirinkite —";
    this.value = "";
    this.disabled = false;
    this.options = [];
  }

  static override styles = [controlStyles, css`:host { display: block; }`];

  override render() {
    return html`
      <label for="sel">${this.label}</label>
      <select
        id="sel"
        .value=${this.value}
        ?disabled=${this.disabled}
        @change=${this.onChange}
      >
        <option value="">${this.placeholder}</option>
        ${this.options.map(
          (o) => html`<option value=${o.value} ?selected=${o.value === this.value}>${o.label}</option>`,
        )}
      </select>
    `;
  }

  private onChange(e: Event) {
    const value = (e.target as HTMLSelectElement).value;
    this.dispatchEvent(
      new CustomEvent("change", { detail: { value }, bubbles: true, composed: true }),
    );
  }
}

customElements.define("modulina-select", ModulinaSelect);
